/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react';
import { Component, forwardRef, createRef } from 'react';
import { findDOMNode } from 'react-dom';
import SpatialNavigationWrapper from './SpatialNavigationWrapper';

export interface IFocusableParentProps {
  forwardedRef?: React.MutableRefObject<HTMLDivElement>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config?: any;
  defaultSection?: boolean;
  sectionName: string;
  id?: string;
  children: React.ReactNode | undefined;
  className?: string;
  onClick?: () => void;
  onFocus?: () => void;
  onLeave?: () => void;
}

export class FocusableParent extends Component<IFocusableParentProps> {
  sectionId;
  parentRef;
  constructor(props) {
    super(props);

    this.parentRef = props.forwardedRef || createRef();
    this.sectionId = '';
  }

  componentDidMount() {
    this.sectionId = this.addFocusable();

    if (this.parentRef.current) {
      this.parentRef.current.addEventListener('sn:unfocused', this.onLeave);
    }
  }

  componentWillUnmount() {
    if (this.parentRef.current) {
      this.parentRef.current.removeEventListener('sn:unfocused', this.onLeave);
    }
    FocusableParent.removeFocusable(this.sectionId);
  }

  onLeave = (data) => {
    const { onLeave } = this.props;
    const { nextSectionId } = data.detail;
    if (nextSectionId !== this.sectionId && onLeave) onLeave();
  };

  addFocusable() {
    const { config, defaultSection, sectionName, id } = this.props;
    const ref = this.parentRef;
    const domNode = findDOMNode(ref.current);

    return SpatialNavigationWrapper.addFocusable(domNode, {
      config,
      defaultSection,
      id,
      sectionName,
    });
  }

  static removeFocusable(sectionId) {
    SpatialNavigationWrapper.removeFocusable(sectionId);
  }

  render() {
    const { className, children, id, onClick, onFocus } = this.props;
    return (
      <div className={className} id={id} ref={this.parentRef} onClick={onClick} onFocus={onFocus}>
        {children}
      </div>
    );
  }
}

export default forwardRef(
  (
    props: Omit<IFocusableParentProps, 'forwardedRef'>,
    ref: React.MutableRefObject<HTMLDivElement>,
  ) => <FocusableParent forwardedRef={ref} {...props} />,
);
